import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchActiveScanGroups, updateActiveScanGroup } from 'pages/Sspm/components/ExternalIntegrations/api';
import { IScanGroup } from 'pages/Sspm/components/ExternalIntegrations/ScanGroupsSelector';
import api from 'globalPages/settingsPage/api/api';

export const fetchScanGroupsThunk = createAsyncThunk(
  'allInOneScanGroups/fetchScanGroups',
  async ({ tenantGuid }: { tenantGuid: string }) => {
    const options: IScanGroup[] = await api.getScanGroups();
    const activeScanGroup = await fetchActiveScanGroups(tenantGuid);

    let activeGroup = null;
    if (activeScanGroup.current) {
      activeGroup = options.find(group => group.GroupId === activeScanGroup.current);
    }
    let selectedGroup = undefined;
    let visibleScanGroups = false;

    if (activeScanGroup.current) {
      for (const scanGroup of options) {
        if (scanGroup.GroupId === activeScanGroup.current) {
          selectedGroup = scanGroup;
          visibleScanGroups = true;
          break;
        }
      }
    }

    return { options, activeGroup, selectedGroup, visibleScanGroups, connectedGroups: activeScanGroup.scanGroups };
  }
);

export const updateScanGroup = createAsyncThunk(
  'allInOneScanGroups/updateScanGroup',
  async (args: { tenantGuid: string; option: IScanGroup }) => {
    const { tenantGuid, option } = args;
    await updateActiveScanGroup(tenantGuid, option.GroupId);
    return option;
  }
);
